// extracted by css-extract-rspack-plugin
export default {"progressCircle":"IssueItemSubIssuesSummary-module__progressCircle__tCHxh","token":"IssueItemSubIssuesSummary-module__token__Ltvo2"};